module.exports = __webpack_public_path__ + "img/Tenken_top.a2ae989f.png";